import {useOverlayTriggerState as $aGzji$useOverlayTriggerState} from "@react-stately/overlays";
import {useState as $aGzji$useState} from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $89a94a12744b972a$exports = {};

$parcel$export($89a94a12744b972a$exports, "useMenuTriggerState", () => $89a94a12744b972a$export$79fefeb1c2091ac3);


function $89a94a12744b972a$export$79fefeb1c2091ac3(props) {
    let overlayTriggerState = $aGzji$useOverlayTriggerState(props);
    let [focusStrategy1, setFocusStrategy] = $aGzji$useState(null);
    return {
        focusStrategy: focusStrategy1,
        ...overlayTriggerState,
        open (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.open();
        },
        toggle (focusStrategy = null) {
            setFocusStrategy(focusStrategy);
            overlayTriggerState.toggle();
        }
    };
}




export {$89a94a12744b972a$export$79fefeb1c2091ac3 as useMenuTriggerState};
//# sourceMappingURL=module.js.map
